export const waveUiEn = {
  playerApps: {
    title: "Applications",
    subtitle: "Apply to clubs and track your applications",
    apply: "Apply to a club",
    parentBanner: "Viewing as a parent",
    parentHint: "Children's applications are on the parent applications page.",
    viewChildren: "View children's applications",
    mine: "My applications",
    programme: "Programme: {{name}}",
    applied: "Applied {{date}}",
    reviewed: "Reviewed {{date}}",
    withdraw: "Withdraw",
    withdrawTitle: "Withdraw this application?",
    withdrawBody: "This permanently deletes the application to {{club}}.",
    withdrawn: "Application withdrawn",
    empty: "No applications yet",
    emptyBody: "When you apply to a club, it will show up here.",
    loadError: "Applications could not be loaded",
  },
  parentApps: {
    title: "Applications",
    subtitle: "View your children's club applications",
    apply: "Apply for a child",
    selectChild: "Select a child",
    selectHint: "Choose whose applications you want to see",
    selected: "Selected",
    noChildren: "No children are linked yet",
    noChildrenBody: "Link a child account before you can see their applications.",
    dashboard: "Go to dashboard",
    list: "{{name}}'s applications",
    pick: "Select a child to see their applications",
    empty: "No applications yet for {{name}}",
    unnamed: "Child",
  },
  trials: {
    title: "Trial invitations",
    subtitle: "Club trials waiting for a response",
    tabs: "Invitation lists",
    pending: "Pending ({{count}})",
    history: "History ({{count}})",
    emptyPending: "No pending invitations",
    emptyPendingBody: "New trial invitations will appear here.",
    emptyHistory: "No history yet",
    emptyHistoryBody: "Invitations you have answered will appear here.",
    loadError: "Invitations could not be loaded",
  },
  billing: {
    title: "Billing",
    subtitle: "Your subscription, invoices, and transactions",
    current: "Current subscription",
    active: "Active",
    renews: "Renews {{date}}",
    per: "/ {{cycle}}",
    cancel: "Cancel at period end",
    terminate: "Terminate now",
    cancelTitle: "Cancel this subscription?",
    cancelBody: "Access continues until the end of the current period.",
    terminateTitle: "Terminate this subscription?",
    terminateBody: "This ends the subscription immediately. Type TERMINATE to confirm.",
    none: "No active subscription",
    noneBody: "Choose a plan when you are ready.",
    plans: "View plans",
    invoices: "Invoices",
    invoiceCaption: "Invoice history",
    noInvoices: "No invoices yet",
    transactions: "Transactions",
    txCaption: "Billing transactions",
    noTransactions: "No transactions yet",
    invoice: "Invoice",
    date: "Date",
    plan: "Plan",
    amount: "Amount",
    method: "Payment method",
    download: "Download",
    type: "Type",
    status: "Status",
    refund: "Request refund",
    na: "Not available",
    refundSent: "Refund request sent",
  },
  fees: {
    title: "Programme fees",
    subtitle: "Bills for the programmes you are enrolled in",
    parentTitle: "Children's programme fees",
    parentSubtitle: "Bills for your children's programmes",
    outstanding: "Outstanding",
    paidMonth: "Paid this month",
    overdue: "Overdue",
    total: "Total bills",
    unpaidCount: "{{count}} unpaid",
    needsPayment: "Needs payment",
    search: "Search by programme or club",
    club: "Club",
    allClubs: "All clubs",
    programme: "Programme",
    allProgrammes: "All programmes",
    status: "Status",
    allStatus: "All statuses",
    paid: "Paid",
    unpaid: "Unpaid",
    pending: "Pending",
    overdueStatus: "Overdue",
    caption: "Programme fee bills",
    empty: "No bills match these filters",
    child: "Child",
    type: "Type",
    auto: "Automatic",
    manual: "Manual",
    amount: "Amount",
    billed: "Billed",
    due: "Due",
    paidOn: "Paid",
    actions: "Actions",
    pay: "Pay now",
    payment: "Payment",
    paymentBody: "Record that this bill will be paid at the club.",
    na: "Not available",
    noChildren: "No children are linked",
    noChildrenBody: "Link a child account to see programme fees.",
    loadError: "Bills could not be loaded",
  },
  schedule: {
    title: "Training schedule",
    subtitle: "Upcoming sessions for your programmes",
    parentTitle: "Children's schedule",
    parentSubtitle: "Sessions your children are enrolled in",
    tabs: "Schedule views",
    calendar: "Calendar",
    today: "Today ({{count}})",
    todayLabel: "Today's sessions",
    todayHint: "Sessions scheduled for today",
    noPlayer: "Player profile not found",
    noPlayerBody: "Finish the player profile before the schedule can load.",
    loadError: "The schedule could not be loaded",
    previous: "Previous",
    next: "Next",
    todayButton: "Today",
    addToCalendar: "Add to calendar",
  },
  training: {
    title: "Individual training plans",
    subtitle: "Plans written for you by a coach",
    parentTitle: "Children's training plans",
    parentSubtitle: "Plans written for your children",
    tabs: "Plan status",
    active: "Active ({{count}})",
    completed: "Completed ({{count}})",
    other: "Other ({{count}})",
    empty: "No training plans yet",
    emptyBody: "A coach will add a plan when one is ready.",
    pageEmpty: "No plans on this page",
    noneActive: "No active plans on this page",
    loadError: "Training plans could not be loaded",
  },
  welfare: {
    empty: "No injuries recorded",
  },
  coach: {
    scheduleSubtitle: "Sessions you are coaching",
    trialsTitle: "Trial participants",
    trialsSubtitle: "Players on trial in your programmes",
    filter: "Trial status",
    all: "All statuses",
    active: "Active",
    completed: "Completed",
    converted: "Converted",
    notSelected: "Not selected",
    player: "Player",
    programme: "Programme",
    type: "Trial type",
    start: "Start",
    rating: "Rating",
    status: "Status",
    actions: "Actions",
    evaluate: "Evaluate",
    empty: "No trial participants",
    caption: "Trial participants",
    rosterTitle: "Roster",
    rosterSubtitle: "Players in this club's programmes",
    rosterEmpty: "No players on the roster yet",
    financeTitle: "Finance",
    financeSubtitle: "Income, expenses, and profit for this club",
    income: "Income (30 days)",
    expenses: "Expenses (30 days)",
    profit: "Net (30 days)",
    export: "Export CSV",
    add: "Add transaction",
    lateFees: "Late fees",
    lateFeesBody: "The fee uses this club's amount at the time it is applied. Bills that are already overdue are left as they are unless you include them.",
    lateFeesOn: "Turn late fees on",
    lateFeeType: "Fee type",
    lateFeeFixed: "Fixed amount",
    lateFeePercent: "Percentage of the bill",
    lateFeeAmount: "Amount",
    lateFeePercentLabel: "Percent",
    lateFeeMax: "Maximum fee",
    lateFeeGrace: "Grace days",
    applyExisting: "Also charge bills that are already overdue",
    lateFeesFrom: "Bills that become overdue after {{date}} can be charged.",
    lateFeesSaved: "Late fee settings saved",
    lateFeesInvalid: "Enter the club's fee amount before saving.",
    appsTitle: "Applications",
    appsSubtitle: "Players applying to this club",
    noClub: "No club selected",
    noClubBody: "Choose a club before managing applications.",
    pending: "Pending ({{count}})",
    approved: "Approved ({{count}})",
    rejected: "Rejected ({{count}})",
    tabs: "Application status",
  },
  specialist: {
    assignmentsTitle: "Assigned matches",
    assignmentsSubtitle: "Matches you are refereeing",
    caption: "Referee assignments",
    date: "Date",
    match: "Match",
    venue: "Venue",
    status: "Status",
    action: "Action",
    empty: "No matches assigned yet",
    dateTbd: "Date to be confirmed",
    assigned: "Assigned",
    enterResult: "Enter result",
    accept: "Accept",
    decline: "Decline",
    vs: "{{home}} vs {{away}}",
    checkInTitle: "Event check-in",
    talentTitle: "Player database",
    talentSubtitle: "Players who opted in to be searched",
  },
  shared: {
    exploreTitle: "Explore",
    exploreSubtitle: "Discover clubs, players, and tournaments",
    search: "Search",
    exploreTabs: "Explore categories",
    players: "Players",
    clubs: "Clubs",
    tournaments: "Tournaments",
    matches: "Matches",
    messagesTitle: "Messages",
    messagesSubtitle: "Your conversations",
    conversations: "Conversations",
    pick: "Select a conversation to start messaging",
    profileTitle: "Profile",
    profileSubtitle: "Your account and personal information",
    profileTabs: "Profile sections",
    personal: "Personal",
    security: "Security",
    roles: "Roles",
    notifications: "Notifications",
    history: "History",
  },
  admin: {
    approvalsTitle: "Role approvals",
    approvalsSubtitle: "Review requests to change role",
    moderationTitle: "Moderation",
    moderationSubtitle: "Reported content waiting for a decision",
    superTitle: "Platform",
    superSubtitle: "Administration and system overview",
    pending: "Pending reports",
    reviewed: "Reviewed",
  },
  matches: {
    title: "Matches",
    subtitle: "Fixtures, lineups, results, and RSVP",
    tabs: "Match lists",
    upcoming: "Upcoming",
    completed: "Completed",
    loadError: "Matches could not be loaded",
    emptyUpcoming: "No upcoming matches",
    emptyCompleted: "No completed matches",
  },
};

export const waveUiMs = {
  playerApps: {
    title: "Permohonan",
    subtitle: "Mohon ke kelab dan jejak permohonan anda",
    apply: "Mohon ke kelab",
    parentBanner: "Melihat sebagai ibu bapa",
    parentHint: "Permohonan anak ada di halaman permohonan ibu bapa.",
    viewChildren: "Lihat permohonan anak",
    mine: "Permohonan saya",
    programme: "Program: {{name}}",
    applied: "Dimohon {{date}}",
    reviewed: "Disemak {{date}}",
    withdraw: "Tarik balik",
    withdrawTitle: "Tarik balik permohonan ini?",
    withdrawBody: "Ini memadam permohonan ke {{club}} secara kekal.",
    withdrawn: "Permohonan ditarik balik",
    empty: "Belum ada permohonan",
    emptyBody: "Selepas anda memohon ke kelab, ia akan muncul di sini.",
    loadError: "Permohonan tidak dapat dimuatkan",
  },
  parentApps: {
    title: "Permohonan",
    subtitle: "Lihat permohonan kelab anak-anak anda",
    apply: "Mohon untuk anak",
    selectChild: "Pilih anak",
    selectHint: "Pilih permohonan siapa yang anda mahu lihat",
    selected: "Dipilih",
    noChildren: "Belum ada anak dipautkan",
    noChildrenBody: "Pautkan akaun anak sebelum permohonan boleh dilihat.",
    dashboard: "Ke papan pemuka",
    list: "Permohonan {{name}}",
    pick: "Pilih anak untuk melihat permohonan mereka",
    empty: "Belum ada permohonan untuk {{name}}",
    unnamed: "Anak",
  },
  trials: {
    title: "Jemputan percubaan",
    subtitle: "Percubaan kelab yang menunggu jawapan",
    tabs: "Senarai jemputan",
    pending: "Menunggu ({{count}})",
    history: "Sejarah ({{count}})",
    emptyPending: "Tiada jemputan menunggu",
    emptyPendingBody: "Jemputan percubaan baharu akan muncul di sini.",
    emptyHistory: "Belum ada sejarah",
    emptyHistoryBody: "Jemputan yang telah dijawab akan muncul di sini.",
    loadError: "Jemputan tidak dapat dimuatkan",
  },
  billing: {
    title: "Bil",
    subtitle: "Langganan, invois, dan transaksi anda",
    current: "Langganan semasa",
    active: "Aktif",
    renews: "Dibaharui {{date}}",
    per: "/ {{cycle}}",
    cancel: "Batal pada akhir tempoh",
    terminate: "Tamatkan sekarang",
    cancelTitle: "Batalkan langganan ini?",
    cancelBody: "Akses berterusan sehingga akhir tempoh semasa.",
    terminateTitle: "Tamatkan langganan ini?",
    terminateBody: "Ini menamatkan langganan serta-merta. Taip TERMINATE untuk sahkan.",
    none: "Tiada langganan aktif",
    noneBody: "Pilih pelan apabila anda bersedia.",
    plans: "Lihat pelan",
    invoices: "Invois",
    invoiceCaption: "Sejarah invois",
    noInvoices: "Belum ada invois",
    transactions: "Transaksi",
    txCaption: "Transaksi bil",
    noTransactions: "Belum ada transaksi",
    invoice: "Invois",
    date: "Tarikh",
    plan: "Pelan",
    amount: "Jumlah",
    method: "Kaedah bayaran",
    download: "Muat turun",
    type: "Jenis",
    status: "Status",
    refund: "Mohon bayaran balik",
    na: "Tidak tersedia",
    refundSent: "Permohonan bayaran balik dihantar",
  },
  fees: {
    title: "Yuran program",
    subtitle: "Bil untuk program yang anda sertai",
    parentTitle: "Yuran program anak",
    parentSubtitle: "Bil untuk program anak-anak anda",
    outstanding: "Tertunggak",
    paidMonth: "Dibayar bulan ini",
    overdue: "Lewat",
    total: "Jumlah bil",
    unpaidCount: "{{count}} belum bayar",
    needsPayment: "Perlu bayaran",
    search: "Cari program atau kelab",
    club: "Kelab",
    allClubs: "Semua kelab",
    programme: "Program",
    allProgrammes: "Semua program",
    status: "Status",
    allStatus: "Semua status",
    paid: "Dibayar",
    unpaid: "Belum bayar",
    pending: "Menunggu",
    overdueStatus: "Lewat",
    caption: "Bil yuran program",
    empty: "Tiada bil sepadan dengan penapis ini",
    child: "Anak",
    type: "Jenis",
    auto: "Automatik",
    manual: "Manual",
    amount: "Jumlah",
    billed: "Dibilkan",
    due: "Tarikh akhir",
    paidOn: "Dibayar",
    actions: "Tindakan",
    pay: "Bayar sekarang",
    payment: "Bayaran",
    paymentBody: "Rekod bahawa bil ini akan dibayar di kelab.",
    na: "Tidak tersedia",
    noChildren: "Tiada anak dipautkan",
    noChildrenBody: "Pautkan akaun anak untuk melihat yuran program.",
    loadError: "Bil tidak dapat dimuatkan",
  },
  schedule: {
    title: "Jadual latihan",
    subtitle: "Sesi akan datang untuk program anda",
    parentTitle: "Jadual anak",
    parentSubtitle: "Sesi yang disertai anak-anak anda",
    tabs: "Paparan jadual",
    calendar: "Kalendar",
    today: "Hari ini ({{count}})",
    todayLabel: "Sesi hari ini",
    todayHint: "Sesi yang dijadualkan hari ini",
    noPlayer: "Profil pemain tidak dijumpai",
    noPlayerBody: "Lengkapkan profil pemain sebelum jadual boleh dimuatkan.",
    loadError: "Jadual tidak dapat dimuatkan",
    previous: "Sebelum",
    next: "Seterusnya",
    todayButton: "Hari ini",
    addToCalendar: "Tambah ke kalendar",
  },
  training: {
    title: "Pelan latihan individu",
    subtitle: "Pelan yang ditulis jurulatih untuk anda",
    parentTitle: "Pelan latihan anak",
    parentSubtitle: "Pelan yang ditulis untuk anak-anak anda",
    tabs: "Status pelan",
    active: "Aktif ({{count}})",
    completed: "Selesai ({{count}})",
    other: "Lain-lain ({{count}})",
    empty: "Belum ada pelan latihan",
    emptyBody: "Jurulatih akan menambah pelan apabila ia sedia.",
    pageEmpty: "Tiada pelan pada halaman ini",
    noneActive: "Tiada pelan aktif pada halaman ini",
    loadError: "Pelan latihan tidak dapat dimuatkan",
  },
  welfare: {
    empty: "Tiada kecederaan direkod",
  },
  coach: {
    scheduleSubtitle: "Sesi yang anda kendalikan",
    trialsTitle: "Peserta percubaan",
    trialsSubtitle: "Pemain dalam percubaan program anda",
    filter: "Status percubaan",
    all: "Semua status",
    active: "Aktif",
    completed: "Selesai",
    converted: "Ditukar jadi ahli",
    notSelected: "Tidak dipilih",
    player: "Pemain",
    programme: "Program",
    type: "Jenis percubaan",
    start: "Mula",
    rating: "Penilaian",
    status: "Status",
    actions: "Tindakan",
    evaluate: "Nilai",
    empty: "Tiada peserta percubaan",
    caption: "Peserta percubaan",
    rosterTitle: "Senarai pemain",
    rosterSubtitle: "Pemain dalam program kelab ini",
    rosterEmpty: "Belum ada pemain dalam senarai",
    financeTitle: "Kewangan",
    financeSubtitle: "Pendapatan, perbelanjaan, dan untung kelab ini",
    income: "Pendapatan (30 hari)",
    expenses: "Perbelanjaan (30 hari)",
    profit: "Bersih (30 hari)",
    export: "Eksport CSV",
    add: "Tambah transaksi",
    lateFees: "Yuran lewat",
    lateFeesBody: "Yuran menggunakan amaun kelab pada masa ia dikenakan. Bil yang sudah tertunggak dibiarkan melainkan anda sertakan.",
    lateFeesOn: "Hidupkan yuran lewat",
    lateFeeType: "Jenis yuran",
    lateFeeFixed: "Amaun tetap",
    lateFeePercent: "Peratus daripada bil",
    lateFeeAmount: "Amaun",
    lateFeePercentLabel: "Peratus",
    lateFeeMax: "Had yuran",
    lateFeeGrace: "Hari tangguh",
    applyExisting: "Kena juga pada bil yang sudah tertunggak",
    lateFeesFrom: "Bil yang menjadi tertunggak selepas {{date}} boleh dikenakan yuran.",
    lateFeesSaved: "Tetapan yuran lewat disimpan",
    lateFeesInvalid: "Masukkan amaun yuran kelab sebelum simpan.",
    appsTitle: "Permohonan",
    appsSubtitle: "Pemain yang memohon ke kelab ini",
    noClub: "Tiada kelab dipilih",
    noClubBody: "Pilih kelab sebelum mengurus permohonan.",
    pending: "Menunggu ({{count}})",
    approved: "Diluluskan ({{count}})",
    rejected: "Ditolak ({{count}})",
    tabs: "Status permohonan",
  },
  specialist: {
    assignmentsTitle: "Perlawanan ditugaskan",
    assignmentsSubtitle: "Perlawanan yang anda kendalikan sebagai pengadil",
    caption: "Tugasan pengadil",
    date: "Tarikh",
    match: "Perlawanan",
    venue: "Tempat",
    status: "Status",
    action: "Tindakan",
    empty: "Belum ada perlawanan ditugaskan",
    dateTbd: "Tarikh belum ditetapkan",
    assigned: "Ditugaskan",
    enterResult: "Masukkan keputusan",
    accept: "Terima",
    decline: "Tolak",
    vs: "{{home}} lawan {{away}}",
    checkInTitle: "Daftar masuk acara",
    talentTitle: "Pangkalan pemain",
    talentSubtitle: "Pemain yang membenarkan carian",
  },
  shared: {
    exploreTitle: "Terokai",
    exploreSubtitle: "Temui kelab, pemain, dan kejohanan",
    search: "Cari",
    exploreTabs: "Kategori terokai",
    players: "Pemain",
    clubs: "Kelab",
    tournaments: "Kejohanan",
    matches: "Perlawanan",
    messagesTitle: "Mesej",
    messagesSubtitle: "Perbualan anda",
    conversations: "Perbualan",
    pick: "Pilih perbualan untuk mula menghantar mesej",
    profileTitle: "Profil",
    profileSubtitle: "Akaun dan maklumat peribadi anda",
    profileTabs: "Bahagian profil",
    personal: "Peribadi",
    security: "Keselamatan",
    roles: "Peranan",
    notifications: "Pemberitahuan",
    history: "Sejarah",
  },
  admin: {
    approvalsTitle: "Kelulusan peranan",
    approvalsSubtitle: "Semak permintaan tukar peranan",
    moderationTitle: "Moderasi",
    moderationSubtitle: "Kandungan yang dilaporkan dan menunggu keputusan",
    superTitle: "Platform",
    superSubtitle: "Pentadbiran dan gambaran sistem",
    pending: "Laporan menunggu",
    reviewed: "Disemak",
  },
  matches: {
    title: "Perlawanan",
    subtitle: "Jadual, barisan, keputusan, dan pengesahan kehadiran",
    tabs: "Senarai perlawanan",
    upcoming: "Akan datang",
    completed: "Selesai",
    loadError: "Perlawanan tidak dapat dimuatkan",
    emptyUpcoming: "Tiada perlawanan akan datang",
    emptyCompleted: "Tiada perlawanan selesai",
  },
};
